import { capitalizeFirstGroceryWord } from './groceryItemDisplayName.js'

export function mapGroceryItemsDisplayNames(items) {
  if (!Array.isArray(items)) return items
  return items.map((row) =>
    row && typeof row === 'object'
      ? { ...row, item: capitalizeFirstGroceryWord(row.item) }
      : row
  )
}

export function loadInitialGroceryListFromStorage(storage = globalThis.localStorage) {
  try {
    const saved = storage?.getItem?.('grocery_list')
    if (!saved) return []
    const parsed = JSON.parse(saved)
    if (!Array.isArray(parsed) || parsed.length === 0) return []
    return mapGroceryItemsDisplayNames(parsed)
  } catch {
    return []
  }
}
